namespace TabAurous.OMS {
    export namespace SubCategoryMasterService {
        export const baseUrl = 'OMS/SubCategoryMaster';

        export declare function Create(request: Serenity.SaveRequest<SubCategoryMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SubCategoryMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SubCategoryMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<SubCategoryMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/SubCategoryMaster/Create",
            Update = "OMS/SubCategoryMaster/Update",
            Delete = "OMS/SubCategoryMaster/Delete",
            Retrieve = "OMS/SubCategoryMaster/Retrieve",
            List = "OMS/SubCategoryMaster/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SubCategoryMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
